import { render, staticRenderFns } from "./Cr.vue?vue&type=template&id=683c7bc3&scoped=true"
import script from "./Cr.vue?vue&type=script&lang=js"
export * from "./Cr.vue?vue&type=script&lang=js"
import style0 from "./Cr.vue?vue&type=style&index=0&id=683c7bc3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683c7bc3",
  null
  
)

export default component.exports